import React from 'react'
import { useState } from 'react'
import axios from 'axios';
//cspell:disable

function Useletter() {
  const [email,setEmail]=useState();
  const handleLogin = async () => {
    try {
      const response = await axios.post('http://localhost:4000/user/register', {
        email,
      });

      // Success
      console.log('Login Success:', response.data);
      // Redirect or save token
    } catch (error) {
      console.error('Login Failed:', error.response?.data || error.message);
    }
  };
  return (
    <div>
      <div className="foter">
    <div className="foter1">
      <div className="paras" style={{fontFamily:"Alata,sans serif"}}>
        <br /><br />
        <p><b>BE THE FIRST</b></p>
        <p>New arrivals. Exclusive previews. First access to <br />
        sales. Sign up to stay in the know.</p></div>
        <div className="input" style={{fontFamily:"Alata,sans serif"}}>
        <input type="email" name='email'  id='sign1' value={email} className='email' onChange={(e)=>setEmail(e.target.value)}  placeholder='Enter Your E-mail Address'required />
      &nbsp;&nbsp;
        <button type="submit" name="" id="sign2" style={{fontSize:"14px"}} onClick={handleLogin}>SIGN UP</button>
        </div>
    </div>
   </div>
    </div>
  )
}

export default Useletter
